import React, { useState } from 'react';
import { IconButton, ListItemText, Menu, MenuItem } from '@mui/material';
import { GridRenderCellParams } from '@mui/x-data-grid-pro';
import { MoreVert } from '@mui/icons-material';
import { useMutation } from '@tanstack/react-query';
import { publishCampaign } from 'api/campaign';
import { Dialog } from 'components';
import { useNotifications } from 'hooks';
import { useNavigate } from 'react-router-dom';
import { AdminRouteList } from 'types';

export const CampaignListActionsCell = ({ cellProps }: { cellProps: GridRenderCellParams }) => {
  const navigate = useNavigate();
  const { setNotification } = useNotifications();
  const campaignId = Number(cellProps.row.id);
  const campaignName = cellProps.row.name;

  const forcePublishCampaign = useMutation({
    mutationFn: () => publishCampaign(campaignId, true),
  });

  const [isConfirmForcePublishDialogOpen, setIsConfirmForcePublishDialogOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const menuOpen = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const onDialogClose = () => {
    setIsConfirmForcePublishDialogOpen(false);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleCampaignForcePublish = async () => {
    await forcePublishCampaign.mutateAsync();
    setNotification('Campaign has been published', 'success');
    handleMenuClose();
    onDialogClose();
  };

  return (
    <>
      <IconButton size="small" onClick={handleClick}>
        <MoreVert />
      </IconButton>
      <Menu anchorEl={anchorEl} open={menuOpen} onClose={handleMenuClose}>
        <MenuItem onClick={() => setIsConfirmForcePublishDialogOpen(true)}>
          <ListItemText primary="Force publish" />
        </MenuItem>
        <MenuItem onClick={() => navigate(`${AdminRouteList.Invoices}?campaignId=${campaignId}`)}>
          <ListItemText primary="Invoices list" />
        </MenuItem>
        <MenuItem
          onClick={() => navigate(`${AdminRouteList.Invoices}?campaignId=${campaignId}&openUploadInvoice=true`)}
        >
          <ListItemText primary="Upload invoice" />
        </MenuItem>
      </Menu>
      <Dialog
        title={`Are you sure you want to publish campaign "${campaignName}"?`}
        content=""
        open={isConfirmForcePublishDialogOpen}
        onClose={onDialogClose}
        primaryActionTitle="Force publish"
        secondaryActionTitle="Cancel"
        onPrimaryActionClick={handleCampaignForcePublish}
        onSecondaryActionClick={onDialogClose}
      />
    </>
  );
};
